// Plain JS on purpose: TypeScript files are compiled to CommonJS (see tsconfig.json), which turns import() into
// a require() and would bundle the SDK with the rest of the app. Here webpack sees the real import() and puts
// the SDK into its own chunk, which is downloaded only when this function is called.
export const loadAppInsightsSdk = () => import('@microsoft/applicationinsights-web')
